import { driverApi } from '../lib/api.ts';
import { LibraryView } from '../components/LibraryView.tsx';

export function DriverLibrary() {
  return (
    <LibraryView api={driverApi} basePath="/api/driver/me/library" queryKey={['driver', 'library']} />
  );
}
